<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    
    <div v-if="cargando" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
      <p class="mt-3 text-muted">Cargando información del informe...</p>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      {{ errorMessage }}
    </div>

    <div v-else-if="datos && Object.keys(datos).length > 0">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="mb-0">
                <i class="fa fa-file-alt mr-2"></i>
                {{ datos.titulo }}
              </h4>
            </div>
            <div class="card-body">
              <!-- Imagen (opcional) -->
              <div v-if="datos.rutaImagen" class="row mb-4">
                <div class="col-md-12">
                  <img 
                    :src="`${filesUrl}${datos.rutaImagen}`" 
                    class="img-fluid rounded" 
                    :alt="datos.titulo"
                    style="max-width: 100%; height: auto;"
                  />
                </div>
              </div>

              <!-- Descripción -->
              <div class="row">
                <div class="col-md-12">
                  <div v-if="datos.descripcion">
                    <div v-html="datos.descripcion"></div>
                    <!-- Botón al PDF completo -->
                    <div v-if="datos.pdf" class="mt-3">
                      <a :href="`${filesUrl}${datos.pdf}`" target="_blank" class="btn btn-primary">
                        <i class="fa fa-file-pdf mr-2"></i>Informe completo aquí
                      </a>
                    </div>
                  </div>
                  <div v-else class="text-muted font-italic">No hay descripción disponible</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="alert alert-warning">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      No se encontraron datos para este informe
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: 'InformeDetail',
  metaInfo: {
    title: "Detalle del Informe",
  },
  components: {
    layoutBreadcrumb
  },
  data: () => ({
    datos: {},
    cargando: false,
    error: false,
    errorMessage: '',
    breadcrumbs: []
  }),
  computed: {
    informeId() {
      return this.$route.params.id;
    }
  },
  methods: {
    async fetchData() {
      if (!this.informeId) {
        this.error = true;
        this.errorMessage = 'ID de informe no válido';
        return;
      }

      this.cargando = true;
      this.error = false;

      try {
        const response = await this.$http.get(this.apiRoute('Informe', 'GetInformeById'), {
          params: { Id: this.informeId }
        });

        if (response.body && response.body.error) {
          this.error = true;
          this.errorMessage = response.body.message || 'Error al cargar los datos del informe';
        } else if (response.body && response.body.data) {
          this.datos = response.body.data;
        } else {
          this.error = true;
          this.errorMessage = 'No se encontraron datos para este informe';
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        this.error = true;
        this.errorMessage = 'Error de conexión al servidor';
      } finally {
        this.cargando = false;
      }
    }
  },
  mounted: async function() {
    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Informes", url: "/informes", icon: "", active: false },
      { name: "Detalle", url: "", icon: "", active: true },
    ];
    
    await this.fetchData();
  }
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.img-fluid {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
</style>
